































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { WxBaseWidget } from '../wxBaseWidget';

@Component({ name: 'wxDatePickerWidget' })
export default class WxDatePickerWidget extends WxBaseWidget {
    private menu = false;

    private formatDb = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
    private formatPicker = 'YYYY-MM-DD';

    private get formattedDate() {
        return this.item[this.fieldName] ? dayjs(this.item[this.fieldName]).format(this.$t('$format.DATE').toString()) : '';
    }

    public get date() {
        return this.item[this.fieldName] ? dayjs(this.item[this.fieldName]).format(this.formatPicker) : dayjs(Date.now()).format(this.formatPicker);
    }

    public set date(value: string) {
        this.item[this.fieldName] = dayjs(value).format(this.formatDb);
        this.$emit('input', dayjs(value).format(this.formatDb));
    }
}
